/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const ShowSnackbar = ({ severity, message, onClose = () => {} }) => {
	return (
		<Snackbar open={!!message} autoHideDuration={3000} onClose={onClose}>
			<Alert onClose={onClose} severity={severity || "info"}>
				{message}
			</Alert>
		</Snackbar>
	);
};

export default ShowSnackbar;
